import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { CreateYearlyBudget } from "Features/YearlyBudget";
import { useTranslation } from "react-i18next";

function NewYearlyBudget () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.newYearlyBudget")} />
            <CreateYearlyBudget />
        </Container>
    );
}

export default NewYearlyBudget;